import { format } from "date-fns";

export const formatDateTime = (time) => {

    const formattedDateTime = format(new Date(time), "MM/dd/yyyy HH:mm:ss");

    return formattedDateTime;

};

export const capitalizeWord = (word) => {

    return word.charAt(0).toUpperCase() + word.slice(1);

};

